/* unplugin-vue-components disabled */import { render } from "./PromocodeCampaignCard.vue?vue&type=template&id=c5f59a8c&scoped=true&ts=true"
import script from "./PromocodeCampaignCard.vue?vue&type=script&lang=ts"
export * from "./PromocodeCampaignCard.vue?vue&type=script&lang=ts"

import "./PromocodeCampaignCard.vue?vue&type=style&index=0&id=c5f59a8c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f59a8c"]])

export default __exports__